import React, { forwardRef } from 'react';


const SecuredImage = forwardRef((props, imgRef) => {
  
  React.useEffect(() => {
    const preventRightClick = (e) => e.preventDefault();
    if(imgRef)
      imgRef.current.addEventListener('contextmenu', preventRightClick);
    return () => {
      if(imgRef && imgRef.current){
        imgRef.current.removeEventListener('contextmenu', preventRightClick);
      }
    };
  }, []);
  return <img alt="" ref={imgRef} {...props} />;
});

// function SecuredImage(props) {
//   const imgRef = React.createRef();
//   React.useEffect(() => {
//     const preventRightClick = (e) => e.preventDefault();
//     imgRef.current.addEventListener('contextmenu', preventRightClick);
//     return () => {
//       if(imgRef.current){
//         imgRef.current.removeEventListener('contextmenu', preventRightClick);
//       }
//     };
//   }, []);
//   return <img alt="" ref={imgRef} {...props} />;
// }

export default SecuredImage;
